import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
  withFooter?: boolean;
}

export default function Layout({ children, withFooter = true }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">{children}</main>
      {withFooter && <Footer />}
    </div>
  );
}